import { ETooltipArrowDirection } from './ToolTip';

export interface ITooltipPosition {
    left: number;
    top: number;
    arrowDirection: ETooltipArrowDirection;
}

export interface ITooltipPositionOptions {
    cursorX: number;
    cursorY: number;
    tooltipWidth: number;
    tooltipHeight: number;
    offset?: number;
    horizontalMargin?: number;
    verticalMargin?: number;
}

const DEFAULT_OFFSET = 25;
const DEFAULT_HORIZONTAL_MARGIN = 10;
const DEFAULT_VERTICAL_MARGIN = 10;

export const calculateTooltipPosition = (options: ITooltipPositionOptions): ITooltipPosition => {
    const {
        cursorX,
        cursorY,
        tooltipWidth,
        tooltipHeight,
        offset = DEFAULT_OFFSET,
        horizontalMargin = DEFAULT_HORIZONTAL_MARGIN,
        verticalMargin = DEFAULT_VERTICAL_MARGIN
    } = options;

    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;

    let left = cursorX - tooltipWidth / 2;

    if (left < horizontalMargin) {
        left = horizontalMargin;
    } else if (left + tooltipWidth > windowWidth - horizontalMargin) {
        left = windowWidth - tooltipWidth - horizontalMargin;
    }

    const spaceBelow = windowHeight - cursorY;
    const spaceAbove = cursorY;
    const requiredSpace = tooltipHeight + offset;

    let top: number;
    let arrowDirection: ETooltipArrowDirection;

    if (spaceBelow >= requiredSpace) {
        top = cursorY + offset;
        arrowDirection = ETooltipArrowDirection.TOP;
    } else if (spaceAbove >= requiredSpace) {
        top = cursorY - tooltipHeight - offset;
        arrowDirection = ETooltipArrowDirection.BOTTOM;
    } else {
        if (spaceBelow > spaceAbove) {
            top = cursorY + offset;
            arrowDirection = ETooltipArrowDirection.TOP;
        } else {
            top = Math.max(verticalMargin, cursorY - tooltipHeight - offset);
            arrowDirection = ETooltipArrowDirection.BOTTOM;
        }
    }

    return { left, top, arrowDirection };
};
